import { type CSSProperties, type Ref } from 'react'

import { cn } from '@/utils/commonUtil'

import styles from './AnchorTarget.module.scss'

type Props = {
  additionalOffset?: string
  id: string
  isSticky?: boolean
  ref?: Ref<HTMLAnchorElement>
}

export const AnchorTarget = ({ additionalOffset, id, isSticky, ref }: Props) => {
  const style = {
    ...(additionalOffset && { '--additional-offset': additionalOffset }),
  } as CSSProperties

  return <a className={cn(styles.container, { isSticky, styles })} id={id} ref={ref} style={style} tabIndex={-1} />
}
